import { Formik } from "formik";

import { SubmitButton, TextInput, ButtonGroup } from "lcm-iot-commons";
import { useIntl } from "react-intl";
import validator from "validator";
import { useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";

type Props = {
  redirectUri: string | null;
  state: string | null;
  clientId: string | null;
  tryDirectLogin: boolean;
};

export default function EHSignInForm({
  redirectUri,
  state,
  clientId,
  tryDirectLogin = false,
}: Readonly<Props>) {
  const intl = useIntl();
  const loginFormRef = useRef<HTMLFormElement>(null);
  const authenticityToken =
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") || "";

  const validateForm = (values: { login_hint?: string }) => {
    const errors = {};

    if (values.login_hint && !validator.isEmail(values.login_hint)) {
      (errors as $TSFixMe).login_hint = intl.formatMessage({
        id: "validation.email.invalid",
      });
    }
    return errors;
  };

  function DirectLoginSubmit() {
    useEffect(() => {
      if (tryDirectLogin && loginFormRef.current) {
        // we cannot use Formik here, as we need to follow the redirect right away and CORS prevents us from reading the response
        loginFormRef.current.requestSubmit();
      }
    }, [tryDirectLogin, loginFormRef]);

    return null;
  }

  const redirectionModal = () => (
    <Modal
      onHide={/* istanbul ignore next */ () => {}}
      backdrop
      show
      id="redirect-modal"
    >
      <Modal.Header>
        <Modal.Title>
          {intl.formatMessage({ id: "signin.sso_modal.title" })}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {intl.formatMessage({ id: "signin.sso_modal.body" })}
      </Modal.Body>
    </Modal>
  );

  const renderForm = (formProps: $TSFixMe) => (
    <form
      method="post"
      action="/app/id/api/auth/myendress"
      id="myendress-signin-form"
      ref={loginFormRef}
    >
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
      />
      <input type="hidden" name="redirect_uri" value={redirectUri || " "} />
      <input type="hidden" name="state" value={state || " "} />
      <input type="hidden" name="client_id" value={clientId || " "} />
      <TextInput
        {...formProps}
        id="login_hint"
        name="login_hint"
        label={intl.formatMessage({ id: "label.email" })}
        required={!tryDirectLogin}
        autoCorrect="off"
        autoComplete="email"
      />
      <DirectLoginSubmit />
      <ButtonGroup>
        <SubmitButton
          id="endress-sign-in"
          text={intl.formatMessage({
            id: "signin.button.signin.myendress",
          })}
        />
      </ButtonGroup>
    </form>
  );

  return (
    <>
      {tryDirectLogin && redirectionModal()}
      <Formik
        id="eh-signin-form"
        onSubmit={
          /* istanbul ignore next */ () => {
            // form is submitted directly, see DirectLoginSubmit
          }
        }
        initialValues={{}}
        validate={validateForm}
        validateOnBlur={false}
      >
        {renderForm}
      </Formik>
    </>
  );
}
